import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full relative w-16 flex-auto flex-shrink-0 flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timetable_course_card = _resolveComponent("timetable-course-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14], (_, index) => {
      return _createElementVNode("div", {
        key: 'cell-' + index,
        class: "h-16 flex-auto flex-shrink-0 justify-center items-center select-none even:bg-transparent odd:bg-gray-100"
      })
    }), 64)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionList, (section, index) => {
      return (_openBlock(), _createBlock(_component_timetable_course_card, {
        key: index,
        section: section
      }, null, 8, ["section"]))
    }), 128))
  ]))
}